exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".native-data-grid {\n\twidth: 100%;\n\tborder-collapse: collapse;\n}\n\n.native-data-grid thead th {\n\tpadding-left: 24px;\n\tpadding-right: 24px;\n\ttext-align: left;\n}\n\n.native-data-grid tbody td {\n\tpadding-left: 24px;\n\tpadding-right: 24px;\n\theight: 48px;\n\ttext-align: left;\n\tfont-size: 13px;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\t-o-text-overflow: ellipsis;\n\t   text-overflow: ellipsis;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/data-grid/data-grid.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/data-grid/data-grid.css
// module chunks = 0